import { connect } from 'react-redux';
import actions from '../redux/actions/transactions';
import TransactionError from '../component/TransactionError';

const mapStateToProps = (state) => ({
  trans: state.transaction.trans,
  txErrors: state.transaction.txErrors,
  coins: state.setting.coins,
  verifyInfo: state.transaction.verify,
  verifyHistories: state.transaction.verifyHistories,
});

const mapDispatchToProps = (dispatch) => ({
  onSearchTransErrorAction: (params, callback) => {
    dispatch(actions.searchTransErrorAction(params, callback));
  },
  onFetchTransErrorAction: (params, callback) => {
    dispatch(actions.fetchTransErrorAction(params, callback));
  },
  onFetchTransErrorFilterAction: (params, callback) => {
    dispatch(actions.fetchTransErrorFilterAction(params, callback));
  },
  verifyTransaction: (data, callback = () => void (0)) => {
    dispatch(actions.verifyTransaction(data, callback));
  },
  acceptTransaction: (data, callback) => {
    dispatch(actions.acceptTransaction(data, callback));
  },
  deleteTransaction: (params, callback) => {
    dispatch(actions.deleteTransaction(params, callback));
  },
  onFetchVerifyHistory: (params, callback) => {
    dispatch(actions.fetchVerifyHistory(params, callback));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(TransactionError);
